
export const buildCertLabel = (item) =>
  item?.certPrefix ? `${item.applicationNumber}/${item.certPrefix}` : item?.applicationNumber;

export const normaliseCert = (value) => {
  const str = String(value ?? "");
  const idx = str.lastIndexOf("/");
  const num = idx === -1 ? str : str.substring(0, idx);
  const suffix = idx === -1 ? 0 : Number(str.substring(idx + 1)) || 0;
  return `${num}/${suffix}`;
};

export const tickLabel = (value) =>
  value ? `${value} ${Number(value) === 1 ? "Tick" : "Ticks"}` : "-";

export const buildCostRows = (products = [], savedList = [], itemCodeMap = new Map()) => {
  const labels = [...new Set(products.filter((p) => p?.applicationNumber).map(buildCertLabel))];

  return labels.map((label) => {
    const saved = savedList.find((x) => normaliseCert(x.certificateNumber) === normaliseCert(label));
    return {
      label,
      itemCodeName: saved ? itemCodeMap.get(saved.itemCode) ?? "-" : "-",
      tickRating: saved?.tickRating,
    };
  });
};

export const toNameMap = (dropdowns = [], dropdownName) =>
  new Map(dropdowns.filter((d) => d.dropdownName === dropdownName).map((d) => [d.id, d.name]));